import css from './AddExtra.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import classNames from 'classnames'

import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_WHITE } from 'utils/constants/colors'

import BalloonBox from 'components/TextBoxes/BalloonBox'
import { useVisibleEventGoods } from 'hooks/useEvent'

type Props = {
  openCheckout(codeUrl: string): void
}

const AddExtra: React.FC<Props> = (props) => {
  const { openCheckout } = props

  const { t } = useTranslation()
  const eventGoods = useVisibleEventGoods()

  return (
    <BalloonBox infoType={'info'} noPadding fullWidth>
      <div className={css.walletAddExtra}>
        <div className={css.title}>{t('wallet:addExtra_title')}</div>
        <div className={css.boxes}>
          {eventGoods &&
            eventGoods?.map((good, idx) => (
              <div
                key={String(idx)}
                className={classNames(css.box, { [css.disabled]: !good?.codeUrl })}
                onClick={() => {
                  good?.codeUrl && openCheckout(good.codeUrl)
                }}
              >
                <div className={css.icon}>
                  <img src={good.policy.icon} />
                </div>
                <div className={css.text}>{good.policy?.description}</div>
              </div>
            ))}
          {!eventGoods &&
            [0, 1, 2].map((idx) => (
              <div key={String(idx)} className={css.good__skeleton}>
                <Skeleton
                  baseColor={TICKETSMS_COLORS_LIGHTGREY}
                  borderRadius={8}
                  height={56}
                  highlightColor={TICKETSMS_COLORS_WHITE}
                />
              </div>
            ))}
        </div>
      </div>
    </BalloonBox>
  )
}

export default AddExtra
